import { render, staticRenderFns } from "./realTimePosition.vue?vue&type=template&id=473bd7a8&scoped=true"
import script from "./realTimePosition.vue?vue&type=script&lang=js"
export * from "./realTimePosition.vue?vue&type=script&lang=js"
import style0 from "./realTimePosition.vue?vue&type=style&index=0&id=473bd7a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473bd7a8",
  null
  
)

export default component.exports